import I18n from 'I18n';
import { ColumnIcon } from 'foundations-assets/icons/components/ColumnIcon';
import { GridIcon } from 'foundations-assets/icons/components/GridIcon';
import { RowIcon } from 'foundations-assets/icons/components/RowIcon';
import { BUILDING_BLOCK_TYPES } from 'layout-data-lib/GridLayoutDataTree/constants';
export function isBuildingBlock(obj) {
  return obj.isBuildingBlock === true && typeof obj.id === 'string' && (obj.id === BUILDING_BLOCK_TYPES.HORIZONTAL_STACK || obj.id === BUILDING_BLOCK_TYPES.VERTICAL_STACK || obj.id === BUILDING_BLOCK_TYPES.TABLE);
}
export const BUILDING_BLOCKS = () => {
  return [{
    id: BUILDING_BLOCK_TYPES.HORIZONTAL_STACK,
    FoundationsIcon: RowIcon,
    displayName: I18n.text('components.sidebar.treeView.fragmentLabels.row'),
    isBuildingBlock: true
  }, {
    id: BUILDING_BLOCK_TYPES.VERTICAL_STACK,
    FoundationsIcon: ColumnIcon,
    displayName: I18n.text('components.sidebar.treeView.fragmentLabels.column'),
    isBuildingBlock: true
  }, {
    id: BUILDING_BLOCK_TYPES.TABLE,
    FoundationsIcon: GridIcon,
    displayName: I18n.text('components.sidebar.treeView.fragmentLabels.grid'),
    isBuildingBlock: true
  }];
};